import styled from 'styled-components';

// export const Container = styled.div`
//   position: relative;
//   width: 100%;
//   height: calc(100% - 5.3rem);
//   overflow-y: auto;
// `;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 120px;
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3rem;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// export const ButtonContainer = styled.div`
//   position: absolute;
//   left: 0;
//   right: 0;
//   bottom: 50px;
//   padding: 0 2rem;
//   background-color: var(--color-background);
//   max-width: var(--max-width);
//   margin: 0 auto;
// `;
export const ButtonContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 0 2rem 40px;
  background-color: var(--color-background);
  max-width: var(--max-width);
  margin: 0 auto;
  width: 100%;
`;

export const Label = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray25};
`;

export const RequiredMark = styled.div`
  display: inline-block;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.brand300};
`;
